import { createContext, useContext } from "react";

import type { MobileWindowId } from "./MobileWindowState";

export type MobileChromeContextValue = {
  /** The full-screen window opened from the top bar, if any. */
  activeWindow: MobileWindowId | null;
  openWindow: (id: MobileWindowId) => void;
  /** Dismisses the open window (x, Escape, swipe), consuming its history entry. */
  closeWindow: () => void;
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
  scrollLock: number;
};

export const MobileChromeContext =
  createContext<MobileChromeContextValue | null>(null);

export const useMobileChrome = () => {
  const value = useContext(MobileChromeContext);
  if (!value) {
    throw new Error("useMobileChrome must be used inside the mobile layout");
  }
  return value;
};
